import templateUrl from "./locale-switcher.html"
import { LocaleSwitcherController } from "./locale-switcher"

export const LocaleSwitcherComponent = {
    templateUrl,
    controller: LocaleSwitcherController,
    controllerAs: "vm"
}
